import { isEmpty } from 'lodash';
import { makeApiPostRequest, makeRetriableGetRequest } from './apiActions';
import LCServiceClient from '../clients/LCServiceClient';
import { setLCResult, setResult } from './resultActions';
import selectors from '../../rootSelectors';
import { ASSESSMENT_MODALITY, LC } from '../../constants/measure';
import { setNextResumeResultItem } from '../resume/resumeResultActions';

const measure = LC.MEASURE;

export const createResult = () => (dispatch, getStore) => {
    const state = getStore();
    const instId = selectors.getInstId(state, measure);
    const postBody = {
        assessment: LCServiceClient.NAME,
        measure,
        assessment_mode: ASSESSMENT_MODALITY.ONLINE,
        grade_level: selectors.getGrade(state),
        inst_uid: instId,
        period: selectors.getToy(state),
        student_uid: selectors.getUserId(state),
        school_year: selectors.getSchoolYear(state),
        // TODO: replace `|| selectors.getUserId(state)` with `|| undefined` as in other actions
        // after LC supports results without `student_temporal_id`
        student_temporal_id:
            selectors.getStudentTemporalId(state, instId) || selectors.getUserId(state),
    };
    const endpoint = LCServiceClient.constructResultListEndpoint();
    return dispatch(makeApiPostRequest(endpoint, postBody))
        .then(resultJson => {
            dispatch(setResult(resultJson));
            return resultJson.result_id;
        })
        .then(resultId => {
            dispatch(setNextResumeResultItem(resultId));
            return resultId;
        });
};

const updatePassageResult = (operation, data, resultId) => (dispatch, getStore) => {
    const state = getStore();
    const studentUid = selectors.getUserId(state);

    return dispatch(LCServiceClient.patchResult(resultId, operation, data, studentUid)).then(
        response => ({
            ...response,
            resultId,
        }),
    );
};

const createCurrentResultId = () => (dispatch, getStore) => {
    const state = getStore();
    const result = selectors.findResultFor(state, { measure, isComplete: false });

    if (!result) return dispatch(createResult()).then(data => data.resultId);
    return Promise.resolve(result.id);
};

export const saveComprehensionResponse = (response, isLast) => dispatch => {
    return dispatch(createCurrentResultId())
        .then(resultId =>
            dispatch(
                updatePassageResult(
                    LCServiceClient.RESULT_OPERATION.ADD_COMPREHENSION_RESPONSE,
                    response,
                    resultId,
                ),
            ),
        )
        .then(data => {
            if (isLast) dispatch(setNextResumeResultItem(data.resultId));
        });
};

export const getPassage = (passageId, retryActionName) => dispatch => {
    const config = { id: passageId };
    const endpoint = LCServiceClient.constructPassageEndpoint(config);
    return dispatch(makeRetriableGetRequest(endpoint, retryActionName)).then(contentJson => {
        if (contentJson) return contentJson;
        return Promise.reject(contentJson);
    });
};

export const getStudentResults = (shouldSetResult = true) => (dispatch, getStore) => {
    const state = getStore();
    const studentId = selectors.getUserId(state);
    const grade = selectors.getGrade(state);
    const period = selectors.getToy(state);
    const schoolYear = selectors.getSchoolYear(state);
    const instId = selectors.getInstId(state, measure);

    return dispatch(LCServiceClient.getResults(studentId, grade, period, schoolYear, instId)).then(
        data => {
            const resultsData = isEmpty(data) ? [] : data;
            if (shouldSetResult)
                resultsData.forEach((resultData, resultIndex) =>
                    dispatch(setLCResult(resultData, resultIndex)),
                );
            return data;
        },
    );
};
